import createModule from "../createModule"
import view from "./view"
import { Creators as CreatorCreators } from "model/creator"
import { Creators as UpdaterCreators } from "model/updater"
import { Creators as DeleterCreators } from "model/deleter"
import { Creators as DialogCreators } from "modules/dialog/model"
import { Creators } from "./model"
import { getFiltersCount, getResultsCount, getSortedSavedSearches, getCurrentFilter, getCurrentFilterId, getCurrentFilterName } from "./selectors"

export default createModule({
  view,
  externalProps: (state, props) => ({
    account: state.global.selected.account,
    modelId: props.modelId,
  }),
  required: ["account", "modelId"],
  data: [{
    resource: "filters",
    as: null,
    url: ({ account, modelId }) => `/api/${account}/filters/${modelId}`,
  }],
  mapStateToProps: (state, props) => ({
    filters: getSortedSavedSearches(state, props),
    filtersCount: getFiltersCount(state, props),
    resultsCount: getResultsCount(state, props),
    currentFilter: getCurrentFilter(state, props),
    name: getCurrentFilterName(state, props),
    id: getCurrentFilterId(state, props),
  }),
  actions: {
    ...Creators,
    del: DeleterCreators.del,
    create: CreatorCreators.create,
    update: UpdaterCreators.update,
    openDialog: DialogCreators.open,
  },
})
